export default {
  type: 'modal',
  instanceName: 'registrar/zero/errors',
  modalClassName: 'modal-form-error',
  modalWidth: '670px',
  modalPadding: '20px',
  fields: {}
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/errorFormConfig.js